export default __webpack_public_path__ + "static/media/dialog.bc81e00c.svg";